// extracted by mini-css-extract-plugin
export default {"link":"donateButton-module__link___syCzZ","donateButton":"donateButton-module__donateButton___FiwAW"};